import { useBiLogger } from "./hooks/use-bi-logger";
import { appMarketSaleBannerClickSrc24Evid188, appMarketSaleBannerImpressionWebMobile, } from "@wix/bi-logger-app-market-data/v2";
import { useMemo } from "react";
export const useManageAppsBi = () => {
    const biLogger = useBiLogger();
    return useMemo(() => ({
        appMarketSaleBannerClicked: ({ msid, origin, }) => {
            biLogger.report(appMarketSaleBannerClickSrc24Evid188({
                sale_name: "manage-apps-sale-banner",
                tag_type: "manage-apps",
                msid,
                market: origin,
            }));
        },
        appMarketSaleBannerImpression: ({ msid, origin, }) => {
            biLogger.report(appMarketSaleBannerImpressionWebMobile({
                sale_name: "manage-apps-sale-banner",
                tag_type: "manage-apps",
                msid,
                market: origin,
            }));
        },
    }), [biLogger]);
};
//# sourceMappingURL=useManageAppsBi.js.map